import {useState} from "react";
import {Button, Menu, MenuItem} from "@mui/material";
import {WhatsApp} from '@mui/icons-material'

export const useMenuPop = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false)
    const [datos, setDatos] = useState({})

    const abrirMenu = (evento, datos) => {

        setAnchorEl(evento.target)
       // setDatos(datos)
        setOpen(true)
    }


    const cerrar = () => {
        setAnchorEl(null)
        setOpen(false)
        setDatos({})
    }
    const MenuPop = ({click, opciones = []}) => {

        return (
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                anchorOrigin={{vertical: 'center', horizontal: 'center'}}
                onClose={() => cerrar()}
                slotProps={{
                    paper: {
                        style: {
                            minWidth: 150,
                            borderRadius: 8
                        },
                    },
                }}

            >
                {opciones.map((it) => (
                    <MenuItem key={it.nombre}>
                        <Button
                            onClick={() => {
                                click(it, datos)
                                setOpen(false)
                            }}
                             sx={{px: 2, fontFamily: 'Poppins'}} startIcon={<WhatsApp/>}
                        >
                            {it.nombre}
                        </Button>
                    </MenuItem>
                ))}
            </Menu>
        )
    }

    return {
        MenuPop,
        abrirMenu
    }
}

